module.exports = __webpack_public_path__ + "static/media/JSNKC4.03267749.png";